export default {
  budgets: 'Budgets {from}%–{to}%',
  reference: 'Reference {value} {unit}',
  ready: 'Ready',
  running: 'Running simulation...',
  createdBy: 'Created by',
  on: 'on',
  clone: 'Clone',
  edit: 'Edit',
  editWhenDone: 'Can be edited once every budget is computed',
  settings: 'Settings',
  showToExternalUsers: 'Show to external users',
  save: 'Save',
  printJsonToConsole: 'Print JSON to console',
  viewMore: 'View more',
  viewMoreWhenDone: 'Available once every budget is computed'
}
